export default __webpack_public_path__ + "static/media/stat-data.288168fa.svg";